import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // import navigate

const PaperDetails = () => {
  const [papers, setPapers] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // initialize navigate

  useEffect(() => {
    fetchData(page);
  }, [page]);

  async function fetchData(currentPage) {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('loggedInUser', 'S3Fwc3A1R2tqeHBPNThNWWp5cy9hdz09');
      fd.append('token', 'kasejfksjdhfywterjwefbdskgfhsdfjh');
      fd.append('programType', 'getPaperDetails');
      fd.append('page', currentPage.toString());
      fd.append('limit', limit.toString());

      const response = await axios.post(
        'https://qp.sarvajna.co.in/api/controller/paper/paperCurl',
        fd
      );

      console.log(response)

      const { getPaperDetails, totalPages } = response.data;
      setPapers((prev) => [...prev, ...getPaperDetails]);
      setTotalPages(Number(totalPages));
    } catch (error) {
      console.error('Error fetching paper data:', error);
    } finally {
      setLoading(false);
    }
  }

  const loadMore = () => {
    if (page < totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  const handleCardClick = (id) => {
    navigate(`/paper-details/${id}`);
  };


 return (
  <div style={{ marginBottom: "6.5rem" }}>

    
          {/* Header with back button */}
          <div className="d-flex align-items-center px-3  bg-white border-bottom  p-2">
            <button
              className="btn btn-link text-primary p-2 me-2"
              onClick={() => navigate(-1)}
              style={{ fontSize: "20px" }}
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            <h6 className="m-0">📄 Papers List</h6>
          </div>
    <div className="container mt-2">
      

      {/* Initial Loader */}
      {loading && papers.length === 0 && (
        <div className="text-center mt-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* Paper List */}
      {papers.map((paper, index) => (
        <div
          key={paper.id || index}
          className="card user-info-card mb-2"
          onClick={() => handleCardClick(paper.id)}
          style={{ cursor: 'pointer' }}
        >
          <div className="card-body">
            <h6>{paper.paperName}</h6>
            <p className="mb-1">
              <strong>Class:</strong> {paper.class}
            </p>
          </div>
        </div>
      ))}

      {/* Load More Button */}
      {page < totalPages && papers.length > 0 && (
        <div className="text-center mt-3">
          <button className="btn btn-primary" onClick={loadMore} disabled={loading}>
            {loading ? 'Loading...' : 'Load More'}
          </button>
        </div>
      )}

      {/* End Message */}
      {page >= totalPages && papers.length > 0 && (
        <div className="text-center mt-3 text-muted">All papers loaded.</div>
      )}
    </div>
  </div>
);

};

export default PaperDetails;
